import { useEffect, useMemo } from 'react';

import toast from 'react-hot-toast';
import { Outlet, useNavigate } from 'react-router-dom';

import { GlobalLoader } from '@liscio/ui';

import { useHomeData } from 'fetch-utils/users/user-hooks';
import { LOGOUT_REDIRECT_URL } from 'modules/authenticate/route-constants';
import { isHostnameOffFirmSubdomain } from 'modules/authenticate/utils/clientHandoffFromMHost';
import { useCpa } from 'stores/cpa';

/**
 * Route wrapper that checks user role ONLY after cpa selection
 * has occurred and gates client users from the firm app.
 *
 * Client users are logged out with an error message on both
 * native and web platforms.
 */
export const RequireFirmEmployeeRoute = () => {
  const { data: homeData, isLoading } = useHomeData();
  const { cpa } = useCpa();
  const navigate = useNavigate();

  const shouldLogoutClientUser = useMemo(() => {
    if (cpa && !isLoading && homeData && !homeData.data.is_employee) {
      return true;
    }

    return false;
  }, [cpa, homeData, isLoading]);

  useEffect(() => {
    if (shouldLogoutClientUser) {
      if (isHostnameOffFirmSubdomain(cpa?.custom_liscio_url)) {
        toast('Redirecting you to your firm…', { duration: 5000 });
      } else {
        toast.error('This app is only available for Firm Employees');
      }
      navigate(LOGOUT_REDIRECT_URL);
    }
  }, [shouldLogoutClientUser, navigate, cpa?.custom_liscio_url]);

  if (isLoading || shouldLogoutClientUser) {
    return <GlobalLoader open />;
  }

  return <Outlet />;
};
